// Shared chart color tokens (resolve CSS variables so they react to light/dark).

export const CATEGORY_ORDER = [
  "Paid Social", "Paid Search", "Native & Discovery", "Real Estate Portals",
  "Programmatic & Display", "Creative & Agency", "Messaging & Chat", "MarTech & Infra", "Other",
];

const CAT_VAR = {
  "Paid Social": "--chart-cat-1",
  "Paid Search": "--chart-cat-4",
  "Native & Discovery": "--chart-cat-3",
  "Real Estate Portals": "--chart-cat-2",
  "Programmatic & Display": "--chart-cat-6",
  "Creative & Agency": "--chart-cat-8",
  "Messaging & Chat": "--chart-cat-5",
  "MarTech & Infra": "--chart-cat-7",
  "Other": "--chart-cat-7",
};

export function categoryColor(category) {
  return `hsl(var(${CAT_VAR[category] || "--chart-cat-7"}))`;
}

export const SERIES = [
  "hsl(var(--chart-cat-1))", "hsl(var(--chart-cat-2))", "hsl(var(--chart-cat-3))",
  "hsl(var(--chart-cat-4))", "hsl(var(--chart-cat-5))", "hsl(var(--chart-cat-6))",
  "hsl(var(--chart-cat-7))", "hsl(var(--chart-cat-8))",
];

export function seriesColor(i) {
  return SERIES[i % SERIES.length];
}

export const FUNNEL_COLORS = {
  leads: "hsl(var(--funnel-leads))",
  visits: "hsl(var(--funnel-visits))",
  bookings: "hsl(var(--funnel-bookings))",
};

export const C = {
  primary: "hsl(var(--primary))",
  spend: "hsl(var(--chart-cat-2))",
  revenue: "hsl(var(--chart-cat-1))",
  roi: "hsl(var(--chart-cat-4))",
  success: "hsl(var(--success))",
  warning: "hsl(var(--warning))",
  danger: "hsl(var(--danger))",
  grid: "hsl(var(--border))",
  axis: "hsl(var(--muted-foreground))",
  muted: "hsl(var(--muted-foreground))",
};

export const axisProps = {
  tick: { fill: "hsl(var(--muted-foreground))", fontSize: 11 },
  tickLine: false,
  axisLine: { stroke: "hsl(var(--border))" },
};

// Shared % label for Pie/Donut slices — renders the share directly on the graph.
// Usage: <Pie labelLine={false} label={piePctLabel} ...>
export function piePctLabel({ cx, cy, midAngle, innerRadius, outerRadius, percent }) {
  if (!percent || percent < 0.04) return null; // skip tiny slivers to avoid clutter
  const RAD = Math.PI / 180;
  const r = innerRadius + (outerRadius - innerRadius) * 0.5;
  const x = cx + r * Math.cos(-midAngle * RAD);
  const y = cy + r * Math.sin(-midAngle * RAD);
  return (
    <text x={x} y={y} fill="#fff" textAnchor="middle" dominantBaseline="central"
      style={{ fontSize: 11, fontWeight: 700, pointerEvents: "none", textShadow: "0 1px 2px rgba(0,0,0,0.45)" }}>
      {`${Math.round(percent * 100)}%`}
    </text>
  );
}

// Outside variant for slim donuts — % placed just beyond the arc, theme-aware.
export function piePctLabelOutside({ cx, cy, midAngle, outerRadius, percent }) {
  if (!percent || percent < 0.03) return null;
  const RAD = Math.PI / 180;
  const r = outerRadius + 12;
  const x = cx + r * Math.cos(-midAngle * RAD);
  const y = cy + r * Math.sin(-midAngle * RAD);
  return (
    <text x={x} y={y} fill="hsl(var(--foreground))" textAnchor={x > cx ? "start" : "end"} dominantBaseline="central"
      style={{ fontSize: 10, fontWeight: 600, pointerEvents: "none" }}>
      {`${Math.round(percent * 100)}%`}
    </text>
  );
}
